import { createStyles, makeUiStyles } from "../styles/styles";
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles(() => createStyles({
  root: {
    padding: 0,
    "&.srOnly": {
      position: "absolute",
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      border: 0,
    },
  },
}), { name: 'FormLegend', index: StylesIndexInjections.UI_ATOMS });
